/*
  Release 2.7 (Nov 3 2026): no tick box before checkout. Secure checkout is never greyed out or blocked.
  The policy line under the button replaces it. Backup of the Oct 21 version: assets/marlas-checkout-terms-backup-2026-11-03.js
*/
(function () {
  if (window.__marlasTerms) return;
  window.__marlasTerms = true;
  function open() {
    document.querySelectorAll('button[name="checkout"].is-disabled, button[name="checkout"][aria-disabled="true"]').forEach(function (b) {
      b.classList.remove('is-disabled');
      b.removeAttribute('aria-disabled');
    });
  }
  open();
  document.addEventListener('DOMContentLoaded', open);
  document.addEventListener('cart-drawer:refreshed', open);
  new MutationObserver(open).observe(document.documentElement, { childList: true, subtree: true });
})();
